import { CalendarDays, MapPin, ChevronDown } from "lucide-react";
import { T } from "@/i18n";

export const Hero = ({ lang, onRegister }) => {
  return (
    <section id="top" data-testid="hero-section" className="relative flex min-h-[92vh] items-center overflow-hidden pt-16">
      <div className="gc-waves" />
      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 py-16 sm:px-6">
        <div className="max-w-3xl">
          {/* Banner image slot — placeholder until the real conference banner is supplied */}
          <div data-testid="banner-placeholder" className="mb-8 hidden items-center justify-center rounded-xl border border-dashed border-[#FFE500]/25 bg-white/[0.03] px-4 py-2.5 text-[11px] uppercase tracking-widest text-white/40 sm:inline-flex">
            Official conference banner will appear here
          </div>
          <p data-testid="hero-eyebrow" className="gc-fade-up font-display text-sm uppercase tracking-[0.4em] text-[#FFE500]">
            {T.hero.eyebrow[lang]} — {T.hero.city[lang]}
          </p>
          <h1 data-testid="hero-title" className="gc-fade-up gc-stagger-1 mt-4 font-display text-5xl font-bold uppercase leading-[1.02] text-white sm:text-6xl lg:text-7xl">
            Glory
            <span className="block text-[#FFE500]">Conference</span>
          </h1>
          <p data-testid="hero-theme" className="gc-fade-up gc-stagger-2 mt-5 font-display text-xl uppercase tracking-wider text-white/90 sm:text-2xl">
            {T.hero.theme[lang]}
          </p>
          <p data-testid="hero-support" className={`gc-fade-up gc-stagger-3 mt-4 max-w-xl text-base text-white/65 sm:text-lg ${lang === "kn" ? "font-kn" : ""}`}>
            {T.hero.support[lang]}
          </p>
          <div className="gc-fade-up gc-stagger-4 mt-7 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/80">
            <span data-testid="hero-dates" className="flex items-center gap-2 font-semibold text-[#FFE500]">
              <CalendarDays className="h-4 w-4" /> {T.hero.dates[lang]}
            </span>
            <span data-testid="hero-venue" className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-[#FFE500]" /> {T.hero.venue[lang]}
            </span>
          </div>
          <div className="mt-9 flex flex-wrap gap-4">
            <button
              data-testid="hero-register-btn"
              onClick={onRegister}
              className="rounded-full bg-[#FFE500] px-8 py-3.5 font-display text-base font-bold uppercase tracking-wider text-[#0B1233] shadow-[0_0_30px_rgba(255,229,0,0.35)] transition-all hover:scale-[1.03] hover:shadow-[0_0_45px_rgba(255,229,0,0.5)]"
            >
              {T.hero.ctaPrimary[lang]}
            </button>
            <a
              data-testid="hero-details-btn"
              href="#details"
              className="rounded-full border border-white/25 px-8 py-3.5 font-display text-base font-semibold uppercase tracking-wider text-white transition-colors hover:border-[#FFE500] hover:text-[#FFE500]"
            >
              {T.hero.ctaSecondary[lang]}
            </a>
          </div>
        </div>
      </div>
      <a href="#details" data-testid="hero-scroll-cue" className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-white/40 transition-colors hover:text-[#FFE500]" aria-label="Scroll down">
        <ChevronDown className="h-7 w-7 animate-bounce" />
      </a>
    </section>
  );
};
